<template>
    <div class="app-bar__wrapper">
        <div class="app-bar">
            <div class="app-bar__identity">
                <img src="@/assets/images/logo.png" class="app-bar__identity-logo" />
                <div class="app-bar__identity-name">
                    {{ $tc("app.name") }}
                </div>
            </div>
            <navigation-bar class="app-bar__navigation"></navigation-bar>
            <div class="app-bar__controls">
                <div class="app-bar__menu">
                    <a @click="toggleMenu" href="#" class="app-bar__link">
                        <span v-html="$tc('icons.bars')"></span>
                    </a>
                </div>
                <div class="app-bar__locales">
                    <locale-selector></locale-selector>
                </div>
                <div class="app-bar__logout" v-if="$features.logout">
                    <a @click="logout" href="#" class="app-bar__link">
                        <span v-html="$tc('icons.logout')"></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="app-bar_vertical" v-if="isMenuOpen">
            <navigation-bar class="app-bar__navigation_vertical"></navigation-bar>
            <div class="app-bar__locales_vertical">
                <locale-selector></locale-selector>
            </div>
            <div class="app-bar__logout_vertical" v-if="$features.logout">
                <a @click="logout" href="#" class="app-bar__link">
                    <span v-html="$tc('icons.logout')"></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import LocaleSelector from "@/components/LocaleSelector.vue";
import {store} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions} = createNamespacedHelpers("arcman");
/**
 *
 * @vue-prop {String} message - greetings message
 */
export default {
    name: "app-bar",
    components: {
        LocaleSelector,
        NavigationBar,
    },
    data() {
        return {
            isMenuOpen: false,
        };
    },
    watch: {
        isMenuOpen(isMenuOpen) {
            if (isMenuOpen) {
                document.addEventListener("click", this.closeIfClickedOutsideMenu);
            }
        },
    },
    methods: {
        ...mapActions({
            logout: "LOGOUT",
        }),
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        closeIfClickedOutsideMenu(event) {
            if (!event.target.closest(".app-bar__menu")) {
                this.isMenuOpen = false;
                document.removeEventListener("click", this.closeIfClickedOutsideMenu);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.app-bar__wrapper::v-deep {
    .app-bar {
        @apply flex flex-row items-center p-2 w-full shadow-lg;
        font-size: $font-medium;
    }

    .app-bar_vertical {
        @apply absolute flex flex-col w-full p-4 shadow-lg;
        font-size: $font-medium;
        background-color: $background-application-color;
        z-index: 888;
        @screen lg {
            @apply hidden;
        }
    }

    .app-bar__identity {
        @apply flex flex-row items-end;
    }

    .app-bar__identity-logo {
        @apply block;
        height: $logo-height;
    }

    .app-bar__identity-name {
        @apply mx-4;
        font-size: $font-large;
    }

    .app-bar__navigation {
        @apply hidden ml-8;
        @screen lg {
            @apply block;
        }

        .sah-nav-item {
            @apply px-2 inline-block text-center;
            .sah-nav-item__icon {
                @apply inline-block text-center;
                height: $menu-icon-size;
                width: $menu-icon-size;
                img {
                    @apply w-full h-full;
                }
            }
            .sah-nav-item__text {
                @apply text-center;
                font-size: $font-small;
                line-height: 0;
            }
        }
    }

    .app-bar__navigation_vertical {
        @apply flex flex-col;
        .sah-nav-item {
            @apply py-2;
            .sah-nav-item__icon {
                width: $menu-icon-size;
                height: $menu-icon-size;
                img {
                    @apply w-full h-full;
                }
            }
        }
    }

    .app-bar__controls {
        @apply flex flex-row items-center ml-auto;
    }

    .app-bar__menu {
        @apply px-2;
        line-height: $logo-height;
        font-size: $logo-height;
        @screen lg {
            @apply hidden;
        }
    }

    .app-bar__locales,
    .app-bar__logout {
        @apply hidden px-2;
        @screen lg {
            @apply block;
        }
    }

    .app-bar__locales_vertical,
    .app-bar__logout_vertical {
        @apply block py-2;
    }

    .app-bar__locales,
    .app-bar__locales_vertical {
        line-height: $font-small;
        font-size: $font-small;
    }
    .app-bar__logout,
    .app-bar__logout_vertical {
        height: $font-medium;
    }

    .sah-nav-item__link,
    .app-bar__link {
        @apply appearance-none no-underline outline-none opacity-50 mr-8;
        color: $text-application-color;
        &:visited {
            color: $text-application-color;
        }
        &:hover {
            @apply opacity-100;
        }
        &.router-link-exact-active {
            @apply font-bold opacity-100;
        }
    }

    .sah-form-select-group,
    .sah-form-select-group__select {
        @apply m-0;
    }
}
</style>
